import React from 'react';
import styled from 'styled-components';
import LogoLoader from './LogoLoader';

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #0f1419 0%, #141a23 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;

const ImavenLoadingScreen = () => {
    return (
        <LoadingOverlay>
            <LogoLoader size={200} />
        </LoadingOverlay>
    );
}

export default ImavenLoadingScreen;